// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Promotion_promotion__InnXc {
  border-radius: 1.1rem;
  background: var(--promotion-gradient);
  padding: 2rem 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.Promotion_promotion__name-container__NnWNF {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.Promotion_promotion__icon__HYGga {
  width: 6rem;
  height: 6rem;
}

.Promotion_promotion__name__PN17M {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
}

.Promotion_promotion__bar-list__c52-9 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.Promotion_promotion__bar-list-item__o4xKU {
  align-self: stretch;
}

.Promotion_promotion__bar-text__K\\+i49 {
  text-align: center;
  font-size: var(--text-base);
  font-weight: 500;
  margin-top: 1rem;
}

.Promotion_promotion__bar-text--done__yX0oi {
  color: var(--green-dark);
}

.Promotion_promotion__achieved-text__6IwoT {
  color: var(--black-light);
  text-align: center;
  font-size: var(--text-base);
  font-weight: 500;
}

.Promotion_promotion__shop-btn__osrob {
  padding: 1rem 8rem 1rem 3rem;
  gap: 7rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Promotions/Promotion/Promotion.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX","sourcesContent":[".promotion {\n  border-radius: 1.1rem;\n  background: var(--promotion-gradient);\n  padding: 2rem 3rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2rem;\n}\n\n.promotion__name-container {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.promotion__icon {\n  width: 6rem;\n  height: 6rem;\n}\n\n.promotion__name {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.promotion__bar-list {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.promotion__bar-list-item {\n  align-self: stretch;\n}\n\n.promotion__bar-text {\n  text-align: center;\n  font-size: var(--text-base);\n  font-weight: 500;\n  margin-top: 1rem;\n}\n\n.promotion__bar-text--done {\n  color: var(--green-dark);\n}\n\n.promotion__achieved-text {\n  color: var(--black-light);\n  text-align: center;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.promotion__shop-btn {\n  padding: 1rem 8rem 1rem 3rem;\n  gap: 7rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"promotion": `Promotion_promotion__InnXc`,
	"promotion__name-container": `Promotion_promotion__name-container__NnWNF`,
	"promotion__icon": `Promotion_promotion__icon__HYGga`,
	"promotion__name": `Promotion_promotion__name__PN17M`,
	"promotion__bar-list": `Promotion_promotion__bar-list__c52-9`,
	"promotion__bar-list-item": `Promotion_promotion__bar-list-item__o4xKU`,
	"promotion__bar-text": `Promotion_promotion__bar-text__K+i49`,
	"promotion__bar-text--done": `Promotion_promotion__bar-text--done__yX0oi`,
	"promotion__achieved-text": `Promotion_promotion__achieved-text__6IwoT`,
	"promotion__shop-btn": `Promotion_promotion__shop-btn__osrob`
};
export default ___CSS_LOADER_EXPORT___;
